import { setNumberWithPoint } from 'utils/utils'
import { Button } from 'avo-ui'
import icEditYellow from 'assets/images/ic-edit-yellow.svg'
import { ACTION_TYPE } from 'constants/constant'

export const TABLE_PRODUCT_TYPE = {
    name: 'Product Type',
    column: [
        {
            name: 'Nama',
            key: 'name',
            className: 'capitalize',
        },
        {
            name: 'Deskripsi',
            key: 'description',
        },
        {
            name: 'Jumlah Produk',
            key: 'product_count',
            render: ({ value }) => <div>{setNumberWithPoint(value)}</div>,
        },
        {
            name: 'Action',
            key: 'action',
            render: ({ item, onClickItem }) => (
                <Button
                    type={'outline'}
                    title={'Edit'}
                    icon={icEditYellow}
                    onClick={() => onClickItem({ id: item?.id, actionType: ACTION_TYPE.EDIT })}
                />
            ),
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
}
